import { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { fetchPolymarketUpdates } from '@/services/api/polymarket';
import pkg from '../../../package.json';
import './TickerBanner.css';

export function TickerBanner() {
  const { t, i18n } = useTranslation('common');
  const isRtl = i18n.dir() === 'rtl';

  const [dynamicMessages, setDynamicMessages] = useState<string[]>([]);

  useEffect(() => {
    async function loadApis() {
      try {
        const lang = i18n.language;
        const polymarketMsgs = await fetchPolymarketUpdates(lang);
        
        setDynamicMessages(polymarketMsgs);
      } catch (err) {
        console.error('Ticker API load error:', err);
      }
    }
    void loadApis();
  }, [i18n.language]);

  const renderMessages = () => {
    return (
      <>
        <span>{t('ticker.bug', 'v{{version}} • Found a bug? Good for you - nobody actually tested this website yet.', { version: pkg.version })}</span>
        {' ••• '}
        <Trans 
          t={t} 
          i18nKey="ticker.algorithm"
          components={[<Link key="link" to="/info?tab=algorithm" style={{ color: 'inherit', textDecoration: 'underline' }} />]}
        />
        {dynamicMessages.length > 0 && ' ••• '}
        {dynamicMessages.join(' ••• ')}
      </>
    );
  };

  return (
    <div className="ticker-banner" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className={`ticker-banner__scroll ${isRtl ? 'ticker-banner__scroll--rtl' : ''}`}>
        <span className="ticker-banner__text">
          {renderMessages()}
        </span>
        <span className="ticker-banner__text" aria-hidden="true">
          {renderMessages()}
        </span>
      </div>
    </div>
  );
}
